<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    chosenCategories: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      rooms: [],
    }
  },
  watch: {
    chosenCategories: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.rooms = this.transformPetData(newVal)
        } else {
          this.rooms = []
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapGetters('hotel/setting', ['productId', 'productName']),
    isRoomsOnlyOne() {
      return this.rooms && this.rooms.length === 1
    },
  },
  methods: {
    transformPetData(rawData) {
      if (!Array.isArray(rawData)) return []

      return rawData.map((item) => {
        return {
          sizeId: item.id,
          categoryTitle: item.categoryTitle,
          price: 0,
          basePrice: 0,
          extraPrice: 0,
          extraBasePrice: 0,
          state: 1,
        }
      })
    },
    settingAllRooms() {
      this.rooms.forEach((r) => {
        r.price = this.rooms[0].price
        r.basePrice = this.rooms[0].basePrice
        r.extraPrice = this.rooms[0].extraPrice
        r.extraBasePrice = this.rooms[0].extraBasePrice
        r.state = this.rooms[0].state
      })
    },
    async validateForm() {
      if (this.getStepData().length === 0) {
        this.$message.error('請至少選擇一個分類')
        return false
      }
      return true
    },
    getStepData() {
      return this.rooms.map((room) => ({
        sizeId: room.sizeId,
        price: room.price,
        basePrice: room.basePrice,
        extraPrice: room.extraPrice,
        extraBasePrice: room.extraBasePrice,
        state: room.state,
        categoryTitle: room.categoryTitle,
      }))
    },
  },
}
</script>
<template>
  <el-form class="step3">
    <div class="header-title">房價設定</div>
    <table>
      <thead>
        <tr>
          <th>分店及分類名稱</th>
          <th>首隻入住原價</th>
          <th>首隻入住售價</th>
          <th>每加一隻原價</th>
          <th>每加一隻售價</th>
          <th>狀態</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(room, index) in rooms">
          <tr :key="index">
            <td>
              <div class="name-col">
                <span class="store-name">{{ productName }}</span>
                <span class="type-name">{{ room.categoryTitle }}</span>
              </div>
            </td>
            <td> <el-input v-model.number="room.basePrice" type="number" :min="0" /> </td>
            <td> <el-input v-model.number="room.price" type="number" :min="0" /> </td>
            <td> <el-input v-model.number="room.extraBasePrice" type="number" :min="0" /> </td>
            <td> <el-input v-model="room.extraPrice" type="number" :min="0" /> </td>
            <td>
              <div class="status-col">
                <span class="status-text">{{ room.state ? '上架' : '下架' }}</span>
                <el-switch v-model="room.state" active-color="#F37736" inactive-color="#EAEAEA" :active-value="1" :inactive-value="0" />
              </div>
            </td>
          </tr>
          <tr v-if="index === 0" :key="'btn-' + index">
            <td colspan="6" class="apply-all-row">
              <el-button class="apply-all-btn" :disabled="isRoomsOnlyOne" @click="settingAllRooms">
                將設定套用至所有分類
              </el-button>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </el-form>
</template>

<style lang="scss" scoped>
.step3 {
  padding: 10px;

  .header-title {
    font-size: 16px;
    color: #333;
    margin-bottom: 20px;
    font-weight: 500;
  }

  table {
    text-align: left;
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;

    thead {
      tr {
        th {
          background-color: #f9f9fb;
          padding: 15px 12px;
          color: #606266;
          font-weight: 500;
          font-size: 14px;
          border: none;

          &:nth-child(1) {
            width: 20%;
          }
          &:nth-child(2) {
            width: 14%;
          }
          &:nth-child(3) {
            width: 14%;
          }
          &:nth-child(4) {
            width: 14%;
          }
          &:nth-child(5) {
            width: 14%;
          }
          &:nth-child(6) {
            width: 150px;
            text-align: right;
            padding-right: 30px;
          }
        }
      }
    }

    tbody {
      tr {
        td {
          padding: 20px 10px;
          vertical-align: middle;
          border-bottom: 1px solid #eaeaea;

          &:first-child {
            padding-left: 12px;
          }
        }
      }
    }
  }
}

.name-col {
  display: flex;
  flex-direction: column;
  gap: 5px;

  .store-name {
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }

  .type-name {
    font-size: 13px;
    color: #333;
  }
}

.status-col {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding-right: 20px;

  .status-text {
    font-size: 14px;
    color: #f37736; // Orange for '上架'
    // To implement dynamic color (gray for inactive), we'd need conditional class
  }
}

.apply-all-row {
  padding: 15px 0;
  border-bottom: 1px solid #eaeaea;
}

.apply-all-btn {
  width: 100%;
  border-radius: 4px;
  border: 1px solid #eaeaea;
  color: #606266;
  background-color: #fff;

  &:hover {
    color: #f37736;
    border-color: #f37736;
    background-color: #fff5f2;
  }
}

::v-deep .el-input__inner {
  text-align: center;
}
</style>
